function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#23E5DB",
  fillRule: "evenodd",
  d: "M47.143 41h-9.746V0h9.746v41zM33.916 20.55c0 9.333-7.594 16.885-16.95 16.885-9.354 0-16.96-7.565-16.96-16.885S7.598 3.664 16.954 3.664c9.356 0 16.962 7.553 16.962 16.886zm-11.834 0c0-2.821-2.289-5.1-5.122-5.1-2.832 0-5.121 2.279-5.121 5.1 0 2.82 2.289 5.1 5.121 5.1 2.833 0 5.122-2.28 5.122-5.1zM71.88 10.3h-6.478L61.6 14.084 57.797 10.3h-6.478v6.56l3.753 3.734-3.753 3.734V30.8h6.58l3.713-3.697 3.714 3.697h6.58v-6.472l-3.753-3.734 3.752-3.734V10.3h-.025z"
});

const SvgOlxLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 41
}, props), _ref);

export default SvgOlxLogo;